<div class="card card-box mb-5">
  <div class="card-header py-3">
    <div class="card-header--title font-size-lg">
      <b><i class="fas fa-cog"></i> Users </b>
    </div>
    <div class="card-header--actions">
<!--      <button class="btn btn-sm btn-neutral-secondary" type="button" (click)="createModal()">-->
<!--                <span class="btn-wrapper&#45;&#45;icon">-->
<!--                    <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>-->
<!--                </span>-->
<!--        <span class="btn-wrapper&#45;&#45;label">-->
<!--                    New User-->
<!--                </span>-->
<!--      </button>-->
    </div>
  </div>
  <div class="d-flex justify-content-between px-4 py-3">
    <form [formGroup]="userForm">
    <div class="search-wrapper btn-group">
          <span class="icon-wrapper text-black">
            <fa-icon [icon]="['fas', 'add']"></fa-icon>
          </span>
      <input  formControlName="category" class="form-control form-control-sm" placeholder="Search terms..." type="search">
      <button class="btn btn-success btn-sm" (click)="create()" [disabled]="!userForm.valid">Add</button>
    </div>
    </form>
  </div>
  <div class="divider"></div>
  <div class="table-responsive">
    <table class="table table-hover text-nowrap mb-0">
      <thead>
      <tr>
        <th class="bg-white text-center">ID</th>
        <th class="bg-white text-center">CATEGORY</th>
        <th class="bg-white text-center">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let user of users">
        <td class="font-weight-bold text-center">
          # {{user.id}}
        </td>
        <td class="font-weight-bold text-center">
          {{user.category}}
        </td>
        <td class="text-center">
          <div class="btn-group btn-group-sm m-2" role="group" aria-label="Basic example">
            <!--            <button type="button" class="btn btn-warning" (click)="userUpdate(user)"><i class="fas fa-upload"></i></button>-->
            <button *ngIf="user.status!=9" type="button" class="btn btn-danger" (click)="userDelete(errorModal,user.id)"><i
              class="far fa-trash-alt"></i></button>
            <button *ngIf="user.status==9" type="button" class="btn btn-success" (click)="userActive(user.id)" ><i class="fas fa-check-circle"></i></button>
          </div>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
  <div class="card-footer py-3 d-flex justify-content-between">

  </div>
</div>
<!--===========================Add Model===================================-->

<!--<div bsModal #addModal="bs-modal" class="modal fade" tabindex="-1"-->
<!--     role="dialog" aria-labelledby="dialog-sizes-name1">-->
<!--  <div class="modal-dialog modal-dialog-centered modal-lg">-->
<!--    <div class="modal-content">-->
<!--      <div class="modal-header">-->
<!--        <h6 class="modal-title">Create new user</h6>-->
<!--        <button type="button" class="close" (click)="addModal.hide()" aria-label="Close">-->
<!--          <span aria-hidden="true">&times;</span>-->
<!--        </button>-->
<!--      </div>-->
<!--      <div class="modal-body">-->
<!--        <div class="card-body">-->

<!--          <form [formGroup]="userForm">-->
<!--            <input formControlName="user" class="form-control mb-2" placeholder="User Name" type="text">-->
<!--            <input formControlName="name" class="form-control mb-2" placeholder="Full Name" type="text">-->
<!--            <input formControlName="email" class="form-control mb-2" placeholder="Email" type="text">-->
<!--            <input formControlName="mobile" class="form-control mb-2" placeholder="Mobile" type="text">-->

<!--            <input-->
<!--              [ngClass]="{'is-invalid' : userForm.get('password').hasError('required') && userForm.get('password').touched || !userForm.controls.password.valid && userForm.controls.password.dirty }"-->
<!--              formControlName="password" class="form-control password-padding password-border"-->
<!--              placeholder="Enter your password" [type]="'password'">-->
<!--            <p class="validation-p"-->
<!--               [ngClass]="{'display-validation' : userForm.get('password').hasError('required') && userForm.get('password').touched || !userForm.controls.password.valid && userForm.controls.password.dirty }">-->
<!--              *Password must be at least <strong> 8 characters</strong> long..</p>-->

<!--            <input-->
<!--              [ngClass]="{'is-invalid' : userForm.get('confirmPassword').hasError('required') && userForm.get('confirmPassword').touched || !userForm.controls.confirmPassword.valid && userForm.controls.confirmPassword.dirty || userForm.hasError('notSame') && userForm.get('confirmPassword').touched  }"-->
<!--              formControlName="confirmPassword" class="form-control password-padding password-border"-->
<!--              placeholder="Confirm your password" [type]="'password'">-->


<!--            <p class="validation-p"-->
<!--               [ngClass]="{'display-validation' : userForm.get('confirmPassword').hasError('required') && userForm.get('confirmPassword').touched || !userForm.controls.confirmPassword.valid && userForm.controls.confirmPassword.dirty || userForm.hasError('notSame') && userForm.get('confirmPassword').touched  }">-->
<!--              *Passwords <strong>do not match.</strong></p>-->

<!--          </form>-->


<!--        </div>-->
<!--      </div>-->
<!--      <div class="modal-footer">-->
<!--        <button type="button" class="btn btn-link btn-link-dark" (click)="addModal.hide()">Close</button>-->
<!--        &lt;!&ndash;        <button type="button" class="btn btn-primary ml-auto" (click)="addModal.hide()">Save changes</button>&ndash;&gt;-->
<!--        <button class="btn btn-success ladda-button ml-auto" data-style="slide-up"-->
<!--                [ladda]="isLoading" (click)="createUser()">-->
<!--          <span class="ladda-label"> Proceed </span>-->
<!--          <span class="ladda-spinner"></span>-->
<!--          <div class="ladda-progress" style="width: 0px;"></div>-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--&lt;!&ndash;========================Delete Modal=================================&ndash;&gt;-->

<!--<ng-template #errorModal>-->
<!--  <div class="text-center p-5">-->
<!--    <div class="avatar-icon-wrapper rounded-circle m-0">-->
<!--      <div-->
<!--        class="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">-->
<!--        <fa-icon [icon]="['fas', 'times']" class="d-flex align-self-center display-3"></fa-icon>-->
<!--      </div>-->
<!--    </div>-->
<!--    <h4 class="font-weight-bold mt-4">Are you sure you want to delete this entry?</h4>-->
<!--    <p class="mb-0 font-size-lg text-muted">You cannot undo this operation.</p>-->
<!--    <div class="pt-4">-->
<!--      <button (click)="declineDelete()" class="btn btn-pill btn-neutral-secondary mx-1" type="button">-->
<!--                <span class="btn-wrapper&#45;&#45;label">-->
<!--                    Cancel-->
<!--                </span>-->
<!--      </button>-->
<!--      <button (click)="confirmDelete()" class="btn btn-pill btn-danger mx-1" type="button">-->
<!--                <span class="btn-wrapper&#45;&#45;label">-->
<!--                    Delete-->
<!--                </span>-->
<!--      </button>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->

<notifier-container></notifier-container>
